import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnTextareaComponent} from './textarea.component';
import {NzInputModule} from 'ng-zorro-antd/input';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [GnTextareaComponent],
  exports: [GnTextareaComponent],
  imports: [
    CommonModule,
    NzInputModule,
    FormsModule
  ],
  entryComponents: []
})
export class GnTextAreaModule {
}
